<template>
  <div class="mic-com notice">
    <van-notice-bar
      @click="onclick"
      :text="config.content"
      left-icon="volume-o"
      :color="config.color"
      :background="config.bg_color"
    />
  </div>
</template>

<script>
import Common from "../mixins/Common";

export default {
  name: "Notice",
  props: {},
  mixins: [Common],
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    onclick() {
      const { link_url } = this.config;
      if (!link_url) return;
      window.location.href = link_url;
    }
  },
  computed: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.notice {
}
</style>
